import React from 'react';
import {Button, Container, Header} from "semantic-ui-react";
import {DateTimePicker} from 'react-widgets';
import momentLocalizer from "react-widgets-moment";
import moment from "moment/moment";
import {dbGet, downloadFileData} from 'utils/ajaxUtils';

class PublishLogDownload extends React.Component {
  constructor(props) {
    super(props);
    moment.locale('en');
    momentLocalizer();
    let now = new Date();
    let firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    let firstOfNextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    this.state = {
      startTime: firstOfMonth,
      endTime: firstOfNextMonth
    }
  }

  updateStartTime = (value) => {
    this.setState({
      startTime: value
    })
  };

  updateEndTime = (value) => {
    this.setState({
      endTime: value
    })
  };

  downloadPublishLogs = () => {
    dbGet('publishlog/download', {
      startTime: this.state.startTime.getTime(),
      endTime: this.state.endTime.getTime()
    }, { responseType: "text/csv" } ).subscribe(response => downloadFileData(response.response, 'publish-logs-export.csv') );
  };

  render() {
    return (
      <Container textAlign='center' className='publish-log-page'>
        <Header as='h1'>Download Publish Log</Header>
        <DateTimePicker value={this.state.startTime} onChange={this.updateStartTime}/>
        <DateTimePicker value={this.state.endTime} onChange={this.updateEndTime}/>
        <Button className='primary'
                size='massive'
                onClick={() => {this.downloadPublishLogs()} }>
          Download
        </Button>
      </Container>
    )
  }
}

export default PublishLogDownload;



// WEBPACK FOOTER //
// ./public/pages/PublishLogDownload/PublishLogDownload.jsx